export default __webpack_public_path__ + "static/media/US_Hero1_1.5eaed8de.png";